import { createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react'

import { Choice } from '@/types/choice'

export interface ChoicesContextProps {
  choices: Choice[]
  setChoices: Dispatch<SetStateAction<Choice[]>>
}

export const ChoicesContext = createContext({} as ChoicesContextProps)

interface ChoicesProviderProps {
  children: ReactNode
}

export const ChoicesProvider = ({ children }: ChoicesProviderProps) => {
  const [choices, setChoices] = useState<ChoicesContextProps['choices']>([])

  useEffect(() => {
    if (!choices) return

    localStorage.setItem('choices', JSON.stringify(choices))
  }, [choices])

  useEffect(() => {
    const lsChoices = localStorage.getItem('choices')

    setChoices(lsChoices ? JSON.parse(lsChoices) : [])
  }, [])

  const value = {
    choices,
    setChoices
  }

  return <ChoicesContext.Provider value={value}>{children}</ChoicesContext.Provider>
}
